import { render, staticRenderFns } from "./h5-block.vue?vue&type=template&id=774b6706&"
import script from "./h5-block.vue?vue&type=script&lang=js&"
export * from "./h5-block.vue?vue&type=script&lang=js&"
import style0 from "./h5-block.vue?vue&type=style&index=0&id=774b6706&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports